import React, { useEffect } from "react";
import { useState } from "react";
import { Navigate } from "react-router-dom"
import "../Routes/homestyles.css"
import AuthServ from "../services/AuthService"

export default function SignInForm() {
    const [usernameVal, setUsernameValue] = useState()
    const [passVal, setPassVal] = useState()
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [message, setMessage] = useState("")

    useEffect(() => {
        console.log(usernameVal)
    }, [usernameVal])
    useEffect(() => {
        console.log(usernameVal)
    }, [passVal])


    function handleUserNameChange(e) {
        setUsernameValue(e.target.value)
    }
    function handlePassChange(e) {
        setPassVal(e.target.value)
    }

    function handleSubmit(e) {
        if (loading) {
            return
        }
        console.log(usernameVal + ": " + passVal)
        setLoading(true)
        AuthServ.login(usernameVal, passVal).then(
            res => {
                if (res.status == 200) {
                    if(res.token){
                        setSuccess(true)
                    }
                    setMessage(res.message)
                }
                // 401 is passwords didn't match
                else {
                    setSuccess(false)
                    setMessage(res.message)
                }
                setLoading(false)
            }
        )
    }


    if (success) {
        
        return (
            <Navigate to="/dashboard" />
        )
    }
    return (
        <React.Fragment>
            <input className="inputField" value={usernameVal} placeholder="username" onChange={(event) => { handleUserNameChange(event) }}>
            </input>
            <input className="inputField" value={passVal} type="password" placeholder="password" onChange={(event) => { handlePassChange(event) }}>
            </input>
            <div className="message">{message}</div>
            <button className="inputButton center row" onClick={handleSubmit}>
                {loading ? <div className="spinner"></div> : "Sign In"}</button>
                
        </React.Fragment>
    )
}